import { GAME_ID, REDUX_ACTIONS } from 'a/rhymeTime/data/constants';

export const initialState = {
  tileIsDragged: false,
  draggedTileLabel: null,
};

const dragAndDropReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.SET_TILE_DRAGGED:
      return {
        ...state,
        tileIsDragged: true,
        draggedTileLabel: action.payload.draggedTileLabel,
      };
    case REDUX_ACTIONS.INIT_DRAG_AND_DROP:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default dragAndDropReducer;
